import {Trans} from '@lingui/macro';
import React, {useEffect, useState} from 'react';

import {useAppSelector} from '../../../../helpers/reduxHelpers';
import {ApiCardGroups, CardGroupModel} from '../../../../models/api/cardGroupModel';
import {fetchApiAsync} from '../../../../services/http/http';
import {getCompany} from '../../../../store/data/company/companySelectors';
import {getAccess} from '../../../../store/data/dataSelectors';
import {SingleChoiceDropdown} from '../dropdowns/singleChoiceDropdown';
import {defaultDropdownWidth, GenericSingleParameterProps} from './genericParameter';

/*
 * Types.
 */

interface GroupParameterProps extends GenericSingleParameterProps<CardGroupModel> {}

/*
 * Component.
 */

export const GroupParameter = (props: GroupParameterProps) => {
  const groups = useGroups();

  return (
    <SingleChoiceDropdown
      {...props}
      items={groups}
      getItemKey={(item) => String(item.id)}
      renderItemLabel={(item) => item.name}
      serializeItemForSearch={(item) => item.name}
      width={defaultDropdownWidth}
      placeholder={<Trans id="rule-editor-select-group">Select a list</Trans>}
    />
  );
};

/*
 * Helpers.
 */

function useGroups() {
  const [groups, setGroups] = useState<ReadonlyArray<CardGroupModel>>([]);
  const accessNamespaces = Object.keys(useAppSelector(getAccess).namespaces);
  const company = useAppSelector(getCompany);

  useEffect(() => {
    // Redux store is not up to date
    fetchApiAsync(ApiCardGroups, `${company.url}/card_groups`).then(setGroups);
  }, [company.url]);

  return groups.filter((group) => accessNamespaces.includes(group.namespace));
}
